import config from './index';

export const IMAGE_TOO_BIG_ERROR_MESSAGE = `File size must not exceed ${config.maxImageSize}MB`;
